import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "light",
};
const modeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.mode = action.payload;
    },
  },
});

export const { setTheme } = modeSlice.actions;
export default modeSlice.reducer;
